/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { notificationLogsRoute } from '@jira/router-routes__servicedesk-notification-logs-routes/src/notificationLogsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { NotificationLogs, LazyNotificationLogs } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const notificationLogsRouteEntry: Route = createEntry(notificationLogsRoute, () => ({
	group: 'servicedesk',
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],

	// eslint-disable-next-line no-restricted-syntax
	component: NotificationLogs,
	forPaint: [LazyAtlassianNavigation, LazyNotificationLogs],
	perfMetricKey: 'jsm-notification-logs-component-load',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
